import { FilterData } from 'path-shared/models/filter-data';
import { SortDirection } from '@angular/material';


export class TramitarEjecutivasFilter extends FilterData {
  Id_Instit: string;

    constructor(sortField: string, sortDir: SortDirection) {
      super(sortField, sortDir);            
    }
  }
  